'use client';

import { useEffect } from 'react';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { ContentWrap, Css, Responsive } from '@/ui';
import { FlightSearch } from '../../../flights/search/ui/FlightSearch';
import { theme } from '../../../../styles/theme';
import { Shadow } from '../../../../styles/Shadow';
import { IFlightsEnrichmentData } from '../../../flights/shared/flight/domain/models/IEnrichedFlight';
import { useSetFlightsEnrichmentData } from '../../../flights/shared/flight/ui/useSetFlightsEnrichmentData';
import { useFlightStores } from '../../../flights/shared/context/flightStoresContext';
import { getHeadingStyle } from '../../../../styles/utils/getHeadingStyle';

interface IProps {
	flightsEnrichmentData: IFlightsEnrichmentData;
}

export const FlightSearchWidget = observer(
	({ flightsEnrichmentData }: IProps) => {
		const { flightListStore } = useFlightStores();
		useSetFlightsEnrichmentData(flightsEnrichmentData);
		useEffect(() => {
			flightListStore.initialLoad();
		}, []);

		return (
			<StyledContentWrap>
				<Wrapper>
					<Title>Find your flight</Title>
					<FlightSearch submitOnClear={false} />
				</Wrapper>
			</StyledContentWrap>
		);
	},
);

const Title = styled.h2`
	${getHeadingStyle(theme, 'h6')}
	margin: 0;
`;

const StyledContentWrap = styled(ContentWrap)`
	position: relative;
	padding: 0;
	display: grid;
	grid-column-gap: ${theme.grid?.gutter?.vertical?.default};
	grid-template-columns: 2fr 1fr;

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		grid-template-columns: 1fr;
	}
`;

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Css.pxToRem(24)};
	background: ${theme.background?.default};
	border-radius: ${Css.pxToRem(16)};
	padding: ${Css.pxToRem(32)};
	padding-top: ${Css.pxToRem(24)};
	box-shadow: ${Shadow.Large};
	margin-top: -${Css.pxToRem(79)};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		padding: ${Css.pxToRem(16)};
		gap: ${Css.pxToRem(16)};
		margin-top: -${Css.pxToRem(63)};
	}
`;
